import { FormField, FormInput, FormSectionTitle, FormActions, BaseModal } from '@practium/ui';
import { useManufacturerForm } from '../../../hooks/useManufacturerForm';
import styles from '../../ProductFormCard/ProductFormCard.module.css';

interface AddManufacturerModalProps {
	isOpen: boolean;
	onClose: () => void;
	onCreated: (id: string) => void;
}

export const AddManufacturerModal = ({ isOpen, onClose, onCreated }: AddManufacturerModalProps) => {
	const { form, errors, isLoading, set, setCnpj, handleSubmit } = useManufacturerForm({
		onSubmit: onClose,
		onCreated,
	});

	return (
		<BaseModal
			isOpen={isOpen}
			onClose={onClose}
			title="Novo Fabricante"
			isLoading={isLoading}
			actions={
				<FormActions
					onCancel={onClose}
					onSave={handleSubmit}
					isLoading={isLoading}
				/>
			}
		>
			<div className={styles.form}>
				<div className={styles.section}>
					<FormSectionTitle>Informações Gerais</FormSectionTitle>
					<div className={styles.sectionFields}>
						<FormField label="Nome Comercial" required error={errors.tradingName}>
							<FormInput
								placeholder="Ex.: Fertilizantes Heringer S.A."
								value={form.tradingName}
								onChange={(e) => set('tradingName', e.target.value)}
								hasError={!!errors.tradingName}
							/>
						</FormField>
						<div className={styles.row2}>
							<FormField label="Razão Social" error={errors.businessName}>
								<FormInput
									placeholder="Ex.: Heringer"
									value={form.businessName}
									onChange={(e) => set('businessName', e.target.value)}
									hasError={!!errors.businessName}
								/>
							</FormField>
							<FormField label="CNPJ">
								<FormInput
									placeholder="00.000.000/0000-00"
									value={form.cnpj}
									onChange={(e) => setCnpj(e.target.value)}
								/>
							</FormField>
						</div>
					</div>
				</div>
			</div>
		</BaseModal>
	);
};
